export default __webpack_public_path__ + "static/media/q4.56d6117c.svg";